import { getField, updateField } from 'vuex-map-fields';
import AdminService from '@/services/AdminService';

const getDefaultState = function () {
    return {
        id: null,
        discountPercentage: null,
        discountAmount: null,
        expirationDate: null,
        name: null,
        code: null,
        remainingUses: null,
        status: null
    };
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = getDefaultState();

const getters = {
    getField,
    form: (state) => ({
        id: state.id,
        discountPercentage: state.discountPercentage,
        discountAmount: state.discountAmount,
        expirationDate: state.expirationDate,
        name: state.name,
        code: state.code,
        remainingUses: state.remainingUses,
        status: state.status
    }),
};

const mutations = {
    setCoupon(state, value) {
        if (value) {
            // value.Transfers.forEach((status) => {
            //     status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
            // });
            Object.assign(state, value);
        } else {
            Object.assign(state, getDefaultState());
        }
    },

    storeReportDetails(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadCoupon({ commit }, data) {
        const res = await AdminService.getAdminCoupons({
            EntityId: data.id
        });
        commit('setCoupon', res.data.items[0]);
        return res.data;
    },
    async loadCouponAdmin({ commit }, data) {
        const res = await AdminService.getReportAdmin(data.id);
        commit('setCoupon', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
